// extracted by mini-css-extract-plugin
export default {"col":"u3HW3","footerSubscription":"m19IF","wrapperRegular":"Pxq1U","wrapperMedium":"HH5uJ","wrapperBig":"A3eCs","linkWrapper":"maA_k","popoverInfo":"QSwad","popover":"QtLFI"};